import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
import { updateSelectedSnapDisplay } from '../helpers/emblaCarouselSelectedSnapDisplay';
import simpleParallax from 'simple-parallax-js';
const selectors = {
    imageCarouselWithDots: '[data-image-carousel-dots]',
    imageCarouselWithDotsViewport: '[data-image-carousel-dots-viewport]',
    imageCarouselWithDotsPrev: '[data-image-carousel-dots-prev]',
    imageCarouselWithDotsNext: '[data-image-carousel-dots-next]',
    imageCarouselWithDotsIndicator: '[data-image-carousel-dots-indicator]',
    desktopParallaxDots: '[data-desktop-parallax-dots]',
    mobileParallaxDots: '[data-mobile-parallax-dots]',
    parallaxScale: 'data-parallax-scale',
};
const imageCarouselWithDots = () => {
    const imageCarouselWithDots = document.querySelectorAll(selectors.imageCarouselWithDots);
    if (imageCarouselWithDots) {
        imageCarouselWithDots.forEach((carousel) => {
            const viewportNode = carousel.querySelector(selectors.imageCarouselWithDotsViewport);
            const prevButtonNode = carousel.querySelector(selectors.imageCarouselWithDotsPrev);
            const nextButtonNode = carousel.querySelector(selectors.imageCarouselWithDotsNext);
            const snapDisplayNodes = carousel.querySelectorAll(selectors.imageCarouselWithDotsIndicator);
            const options = {
                loop: false,
                align: 'start',
            };
            const embla = EmblaCarousel(viewportNode, options, [ClassNames()]);
            snapDisplayNodes.forEach((node) => {
                updateSelectedSnapDisplay(embla, node);
            });
            if (prevButtonNode && nextButtonNode) {
                prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
                nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
            }
            // Dots
            const parallaxScale = carousel.getAttribute(selectors.parallaxScale);
            const mobileParallaxDots = carousel.querySelector(selectors.mobileParallaxDots);
            const desktopParallaxDots = carousel.querySelector(selectors.desktopParallaxDots);
            if (mobileParallaxDots) {
                new simpleParallax(mobileParallaxDots, { scale: parallaxScale });
            }
            if (desktopParallaxDots) {
                new simpleParallax(desktopParallaxDots, { scale: parallaxScale });
            }
        });
    }
};
export { imageCarouselWithDots };
